const SSH_HOST = "git-ssh.gjz010.com";
const HIDE_DELAY_MS = 180;
const INFO_ICON =
  '<svg class="lucide lucide-info" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>';

let hideTimer: number | undefined;

function buildPopover(): HTMLDivElement {
  const popover = document.createElement("div");
  popover.className = "komorebi-ssh-hint-pop";
  popover.id = "komorebi-ssh-hint-pop";
  popover.setAttribute("role", "tooltip");
  popover.hidden = true;

  const title = document.createElement("p");
  title.className = "komorebi-ssh-hint-pop__title";
  title.textContent = "SSH 连接说明";

  const body = document.createElement("p");
  body.textContent =
    "该地址需通过 cloudflared 隧道访问。请添加到 ~/.ssh/config：";

  const pre = document.createElement("pre");
  const code = document.createElement("code");
  code.textContent = `Host ${SSH_HOST}\n    ProxyCommand nix run nixpkgs#cloudflared -- access tcp --hostname %h`;
  pre.append(code);
  popover.append(title, body, pre);

  return popover;
}

function showHint(popover: HTMLDivElement): void {
  window.clearTimeout(hideTimer);
  popover.hidden = false;
}

function hideHint(popover: HTMLDivElement): void {
  window.clearTimeout(hideTimer);
  hideTimer = window.setTimeout(() => {
    popover.hidden = true;
  }, HIDE_DELAY_MS);
}

function ensureSshHint(): void {
  const sshButton = document.querySelector<HTMLElement>("#repo-clone-ssh");
  if (!sshButton || sshButton.querySelector(".komorebi-ssh-hint-icon")) {
    return;
  }

  const panel = sshButton.closest<HTMLElement>(".clone-panel");
  if (!panel) return;

  sshButton.classList.add("komorebi-ssh-button");
  panel.classList.add("komorebi-ssh-panel");

  const icon = document.createElement("span");
  icon.className = "komorebi-ssh-hint-icon";
  icon.setAttribute("aria-hidden", "true");
  // @license lucide-static v0.468.0 - ISC
  icon.innerHTML = INFO_ICON;

  const popover = buildPopover();
  sshButton.append(icon);
  sshButton.setAttribute("aria-describedby", popover.id);
  panel.append(popover);

  icon.addEventListener("mouseenter", () => {
    showHint(popover);
  });
  icon.addEventListener("mouseleave", () => {
    hideHint(popover);
  });
  icon.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (popover.hidden) showHint(popover);
    else hideHint(popover);
  });
  sshButton.addEventListener("focus", () => {
    showHint(popover);
  });
  sshButton.addEventListener("blur", () => {
    hideHint(popover);
  });
  popover.addEventListener("mouseenter", () => {
    showHint(popover);
  });
  popover.addEventListener("mouseleave", () => {
    hideHint(popover);
  });
}

ensureSshHint();
document.addEventListener("htmx:afterSwap", ensureSshHint);
